import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const templatesSchema: CollectionCreateSchema = {
  name: CollectionName.Templates,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "version_id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "code",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "commodities",
      type: "string[]",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "commodity",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "template_type",
      type: "string",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "title",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "destination_market",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "displayed_description",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "destination_countries",
      type: "string[]",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "exporting_country",
      type: "string",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "industry_access",
      type: "bool",
      infix: true,
      facet: true,
    },
    {
      name: "effective",
      type: "int64",
      sort: true,
      infix: false,
      facet: true,
      optional: true,
    },
    {
      name: "expiry",
      type: "int64",
      sort: true,
      infix: false,
      facet: true,
      optional: true,
    },
    {
      name: "certificate_type",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "major_version",
      type: "int32",
      sort: true,
      facet: true,
      optional: true,
    },
    {
      name: "minor_version",
      type: "int32",
      sort: true,
      optional: true,
    },
    {
      name: "status",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
      facet: true,
    },
    {
      name: "submission_layout",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "pdf_layout",
      type: "string",
      facet: true,
      optional: true,
    },
    {
      name: "xml_layout",
      type: "string",
      facet: true,
      optional: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      facet: false,
      optional: true,
    },
    {
      name: "template_id",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "languages",
      type: "object[]",
      optional: true,
    },
    {
      name: "languages.code",
      type: "string[]",
      facet: true,
      optional: true,
    },
    {
      name: "languages.name",
      type: "string[]",
      facet: true,
      optional: true,
    },
    {
      name: "countries",
      type: "object[]",
      optional: true,
    },
    {
      name: "countries.code",
      type: "string[]",
      facet: true,
      optional: true,
    },
    {
      name: "countries.name",
      type: "string[]",
      facet: true,
      optional: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
